import Suppliers from './modules/suppliers'
import UserExporters from './modules/userExporters'

export default {
  modules: {
    Suppliers,
    UserExporters,
  },
}
